import React, { Component } from 'react';
import Translation from "../../../translation/translation.component";
import Icon from '../../../../icon';
class ApprovalWorkFlow extends Component {
    constructor(props){
        super(props);
        this.state={
                            
        }
    }

    handleClickIcon = () => {
        const {onClick} = this.props;
        if(onClick) {
            onClick(true)
        }
    }

    render() {
      
        return(
            <div className="userprofile-references">
                <Icon
                    customClassName="user-groups"
                    name="users-group"
                    labelValue={<Translation translationKey="approval_workflow" />}
                    size="19px"
                    containerClass="icon-container mb-0"
                    onClick={this.handleClickIcon}
                />                
            </div>
        )
    }
}

export default ApprovalWorkFlow;